import { Status } from ".";

export class Certification {
    id: number;
    name: string;
    status: Status = new Status();
    createdAt: Date = new Date();
    updatedAt: Date;
}
